import axios from 'axios';
import { API_BASE_URL } from './scanApi';

export const getStats = () => axios.get(`${API_BASE_URL}/stats`);
